export default "__VITE_ASSET__C$cOkGbB__"